import React from 'react'
import GeoentityBlock from './GeoentityBlock'
import s from './GeoentityBlockTable.less'
import { checkBlockAspectFitsWhitelist } from './GeoentityBlockUtils'

function Cell(block) {
  return (
    <td>
      <GeoentityBlock block={block} lightMargin />
    </td>
  )
}

function Row({ cells }) {
  return (
    <tr>
      {cells.map((cell, idx) => (
        <Cell key={idx} {...cell} />
      ))}
    </tr>
  )
}

export function reorganizeTable(table) {
  const targetTable = []
  const colLength = table?.[0]?.length ?? 0
  const rowLength = table.length
  for (let c = 0; c < colLength; c++) {
    const row = []
    for (let r = 0; r < rowLength; r++) row.push(table[r][c])
    targetTable.push(row)
  }
  return targetTable
}

export default function GeoentityBlockTable(props) {
  const { data = {} } = props || {}
  if (!checkBlockAspectFitsWhitelist(['normal'], data)) return null
  const { table = [] } = data

  return (
    <table className={s.table}>
      <tbody>
        {reorganizeTable(table).map((row, idx) => (
          <Row key={idx} cells={row} />
        ))}
      </tbody>
    </table>
  )
}
